<template>
    <div class="inline-flex justify-end text-gray-600">
        <div
            class="flex gap-0.5 items-center justify-end p-0.5 bg-gray-50 rounded-lg2 border border-gray-100"
        >
            <Selectable
                v-slot="selectable"
                :value="TimeslotTimeFormat.Format12Hours"
                v-model="dummySelectedTimeslotFormat"
                @update:modelValue="
                    emits('onChange', {
                        format: TimeslotTimeFormat.Format12Hours,
                    })
                "
            >
                <div
                    class="p-2 text-sm rounded-lg2 border"
                    :class="{
                        'bg-white border-gray-200': selectable.active,
                        'border-transparent': !selectable.active,
                    }"
                >
                    12h
                </div>
            </Selectable>
            <Selectable
                v-slot="selectable"
                :value="TimeslotTimeFormat.Format24Hours"
                v-model="dummySelectedTimeslotFormat"
                @update:modelValue="
                    emits('onChange', {
                        format: TimeslotTimeFormat.Format24Hours,
                    })
                "
            >
                <div
                    class="p-2 text-sm rounded-lg2 border"
                    :class="{
                        'bg-white border-gray-200': selectable.active,
                        'border-transparent': !selectable.active,
                    }"
                >
                    24h
                </div>
            </Selectable>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import { TimeslotTimeFormat } from '@/Shared/Hook/useDate'
    import Selectable from '@/Shared/Component/Selectable.vue'

    const emits = defineEmits<{
        onChange: [{ format: TimeslotTimeFormat }]
    }>()

    const props = defineProps({
        currentTimeslotTimeFormat: {
            type: String as () => TimeslotTimeFormat,
            required: true,
        },
    })

    const dummySelectedTimeslotFormat = ref<TimeslotTimeFormat>(
        props.currentTimeslotTimeFormat,
    )
</script>
